import { createContext, useContext, useState, useEffect, useCallback, useSyncExternalStore } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [userData, setUserData] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  const getSnapshot = () => {
    const stored = sessionStorage.getItem('loggedIn');
    return stored === 'true';
  };

  const getServerSnapshot = () => false;

  const subscribe = (callback) => {
    const handler = () => callback();
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  };

  const storageLoggedIn = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  useEffect(() => {
    if (storageLoggedIn) {
      const storedData = sessionStorage.getItem('userData');
      if (storedData) {
        try {
          setUserData(JSON.parse(storedData));
          setLoggedIn(true);
        } catch {
          setLoggedIn(false);
        }
      }
    } else {
      setUserData(null);
      setLoggedIn(false);
    }
    setIsInitializing(false);
  }, [storageLoggedIn]);

  const login = useCallback((data) => {
    sessionStorage.setItem('loggedIn', 'true');
    sessionStorage.setItem('userData', JSON.stringify(data));
    setUserData(data);
    setLoggedIn(true);
    window.dispatchEvent(new Event('storage'));
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('userData');
    setUserData(null);
    setLoggedIn(false);
    window.dispatchEvent(new Event('storage'));
  }, []);

  return (
    <AuthContext.Provider value={{ userData, loggedIn, isInitializing, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}